module.exports = __webpack_public_path__ + "static/media/headshot.5bf9640c.jpg";